module.exports = __webpack_public_path__ + "493fc709.webp";